import { errorLogger } from "@/Common/helpers/logger";
import { apiInstance, gql } from "@/services/httpAdapter";

// Types
import { GraphqlQueryResponse } from "@/Common/api/types/GraphqlQueryResponse";
import { INotification } from "@/Common/api/types/notifications";

export async function updateNotifications(locationId: string, id: string, state: { read?: boolean; archived?: boolean }) {
	const query = gql`
		mutation updateNotification($id: String!, $locationId: String!, $readState: Boolean, $archived: Boolean) {
			updateNotification(id: $id, locationId: $locationId, readState: $readState, archived: $archived) {
				_id
				createdAt
				createdBy
				message
				newNotification
				read
				archived
				userId
				topic
			}
		}
	`;

	const variables = {
		locationId,
		id,
		readState: state.read,
		archived: state.archived,
	};

	try {
		return await apiInstance.post("/graphql", { query, variables });
	} catch (err) {
		errorLogger(err as Error, { function: "updateNotification", message: "Error updating a notification", variables });
		return null;
	}
}

export async function updateAllNotification(locationId: string, userId: string) {
	const query = gql`
		mutation updateAllNotification($locationId: String!, $userId: String) {
			updateAllNotification(locationId: $locationId, userId: $userId) {
				acknowledged
				matchedCount
				modifiedCount
				upsertedCount
				upsertedId
			}
		}
	`;

	const variables = {
		locationId,
		userId,
	};

	try {
		return await apiInstance.post("/graphql", { query, variables });
	} catch (err) {
		errorLogger(err as Error, { function: "updateAllNotification", message: "Error updating all the notifications", variables });
		return null;
	}
}

export async function updateNewNotification(locationId: string, userId: string) {
	const query = gql`
		mutation updateNewNotification($locationId: String!, $userId: String!) {
			updateNewNotification(locationId: $locationId, userId: $userId) {
				userId
			}
		}
	`;

	const variables = {
		locationId,
		userId,
	};

	try {
		return await apiInstance.post("/graphql", { query, variables });
	} catch (err) {
		errorLogger(err as Error, { function: "updateNewNotification", message: "Error updating all the notifications", variables });
		return null;
	}
}

export async function addNotification(locationId: string, userId: string, input: { createdBy: string; message: string }) {
	const query = gql`
		mutation createNotification($locationId: String!, $userId: String!, $input: NotificationInput!) {
			createNotification(locationId: $locationId, userId: $userId, input: $input) {
				_id
				createdAt
				createdBy
				message
				newNotification
				read
				archived
				userId
				topic
			}
		}
	`;

	const variables = {
		locationId,
		input,
		userId,
	};

	try {
		const response: GraphqlQueryResponse<"createNotification", INotification> = await apiInstance.post("/graphql", {
			query,
			variables,
		});
		return response.data.data;
	} catch (err) {
		errorLogger(err as Error, { function: "createNotification", message: "Error creating a new notification", variables });
		return null;
	}
}
